/**
 * @name: sys
 * @description:
 * @author: qq2575896094
 * @time: 2024/4/9
 */

const prefix = '/onlinecs/sys'

/**
 * 登录
 * @type {string}
 */
export const login = `${prefix}/employee/login`

/**
 * futail登录
 * @type {string}
 */
export const futailLogin = `${prefix}/employee/loginFutail`

/**
 * 钉钉扫码登录
 * @type {string}
 */
export const dingtalkLogin = `${prefix}/employee/loginDingtalk`

/**
 * 获取用户信息
 * @type {string}
 */
export const getUserInfo = `${prefix}/employee`

/**
 * 修改密码
 * @type {string}
 */
export const changePasswordUrl = `${prefix}/password`

/**
 * 登出
 * @type {string}
 */
export const logout = `${prefix}/logout`

/**
 * 导出备注
 * @type {string}
 */
export const downloadEmployeeRemarkUrl = `${prefix}/employee/downloadEmployeeRemark`
